// [ODEME-DONUS] (gece isi 1a, 19 Eki 2026) usePaymentReturnPoll icin saglayiciya ozel kontrol islevleri + onayda tek tazeleme.
// Backend DEGISMEZ: eslemeler bugunku cevaplara dayanir (canli-son billing.py: GET /api/billing get_subscription_info +
// _odeme_durumu; POST /api/billing/sync-checkout/{id} sync_checkout_session). Ayrinti: 6_stripe_donus/RAPOR.md 1b, 3b.
import { billingApi } from "../services/api";
import type { DonusSonucu } from "../hooks/usePaymentReturnPoll";

/** Ust cubuk (Header) bu olayi dinler: eBay baglantisi + urun limitleri yeniden okunur. */
export const ABONELIK_GUNCELLENDI_OLAYI = "coderom-subscription-updated";

/** GET /api/billing cevabindan "odeme uygulandi mi" (PayPal). Kosul: saglayici paypal, otomatik tahsilat kurulu
 *  (has_payment_method) ve odeme ekrani artik gerekmiyor (can_pay_now false: paid ya da kartli deneme). */
export function paypalOnayliMi(cevap: any): boolean {
  const s = cevap?.subscription;
  if (!cevap?.success || !s) return false;
  return s.payment_provider === "paypal" && s.has_payment_method === true && s.can_pay_now === false;
}

/** PayPal "pending/processing" donusu: GET /api/billing (yan etkisiz okuma). */
export async function paypalKontrol(): Promise<DonusSonucu> {
  const cevap = await billingApi.getSubscription();
  return paypalOnayliMi(cevap) ? { durum: "onaylandi", veri: cevap } : { durum: "bekliyor", neden: "paypal_bekliyor" };
}

/** Stripe donusu: POST /api/billing/sync-checkout/{id} idempotent (webhook once uyguladiysa "zaten" doner).
 *  "Payment not completed" en cok `tamamlanmamisSinir` deneme beklenir, sonra red. HTTP 403 = baska hesap (terminal). */
export function stripeKontrolOlustur(sessionId: string, tamamlanmamisSinir = 3): () => Promise<DonusSonucu> {
  let tamamlanmamis = 0;
  return async () => {
    let r: any;
    try {
      r = await billingApi.syncCheckout(sessionId);
    } catch (e: any) {
      const st = e?.status ?? e?.apiError?.status;
      if (st === 403) {
        return {
          durum: "reddedildi",
          kod: "wrong_account",
          mesaj: "This payment belongs to a different Coderom account. Sign in with the account you paid from.",
        };
      }
      return { durum: "bekliyor", neden: st ? `http_${st}` : "ag" };
    }
    if (r?.success && !r?.processing && ((r?.credits_added ?? 0) > 0 || r?.plan)) return { durum: "onaylandi", veri: r };
    if (r?.success) return { durum: "bekliyor", neden: "isleniyor" };
    if (/payment not completed/i.test(String(r?.message || ""))) {
      tamamlanmamis += 1;
      if (tamamlanmamis < tamamlanmamisSinir) return { durum: "bekliyor", neden: "tamamlanmadi" };
      return { durum: "reddedildi", kod: "not_completed", mesaj: "Payment wasn't completed - you have not been charged." };
    }
    return { durum: "reddedildi", kod: "rejected", mesaj: r?.message || "We could not verify this payment, so your plan was not changed." };
  };
}

/** Onayda tek tazeleme: abonelik ozeti AuthContext'e (subscription_status dahil — AuthProtected bunu okur) + ust cubuga olay.
 *  `cevap` verilmezse GET /api/billing bir kez okunur. Hata olursa yine de olay gonderilir (ust cubuk kendi okumasini yapar). */
export async function abonelikTazele(updateUser: ((d: any) => void) | undefined, cevap?: any): Promise<any> {
  let veri = cevap?.subscription ? cevap : null;
  try {
    if (!veri) veri = await billingApi.getSubscription();
  } catch (e) {
    veri = null;
  }
  const s = veri?.subscription;
  if (s && updateUser) {
    const d: Record<string, any> = { subscription_status: s.status, subscription_plan: s.plan };
    if (veri?.usage?.max_products !== undefined) d.max_products = veri.usage.max_products;
    if (s.subscription_end !== undefined) d.subscription_end_date = s.subscription_end;
    if (s.trial_end !== undefined) d.trial_end_date = s.trial_end;
    updateUser(d);
  }
  if (typeof window !== "undefined") window.dispatchEvent(new Event(ABONELIK_GUNCELLENDI_OLAYI));
  return veri;
}
